import EventEmitter from 'wolfy87-eventemitter';

export default new EventEmitter();



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/mediator.js